export const SALON_DETAILS_REQUEST = 'SALON_DETAILS_REQUEST';
export const SALON_DETAILS_SUCCESS = 'SALON_DETAILS_SUCCESS';
export const SALON_DETAILS_ERROR = 'SALON_DETAILS_ERROR';
